import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { RouterExtensions } from '@luggagehero/core';
import { BookingStep, BookingTimelineBaseComponent } from '@luggagehero/features/bookings';
import { SharedBookingService } from '@luggagehero/shared/services/bookings';
import { SharedLoggingService } from '@luggagehero/shared/services/logging';
import { SharedWindowService } from '@luggagehero/shared/services/window';
import { TranslateService } from '@ngx-translate/core';

import {
  BookingCanceledStep,
  BookingConfirmedStep,
  DropOffStep,
  LeaveFeedbackStep,
  PickUpStep,
} from '../booking-steps';

@Component({
  selector: 'lh-booking-timeline',
  templateUrl: './booking-timeline.component.html',
  styleUrls: ['./booking-timeline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingTimelineComponent extends BookingTimelineBaseComponent {
  public constructor(
    bookingService: SharedBookingService,
    translate: TranslateService,
    windowService: SharedWindowService,
    elementRef: ElementRef<HTMLDivElement>,
    log: SharedLoggingService,
    cd: ChangeDetectorRef,
    private router: RouterExtensions,
  ) {
    super(bookingService, translate, windowService, elementRef, log, cd);
  }

  buildTimeline(): BookingStep[] {
    return [
      new BookingConfirmedStep(this, this.momentService),
      new BookingCanceledStep(this, this.router),
      new DropOffStep(this, this.windowService),
      // new ExperienceStep(this),
      new PickUpStep(this, this.pricingService),
      new LeaveFeedbackStep(this),
    ];
  }
}
